import { CcRequirementStatus } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcRequirementStatusList = (statusList: types.CcRequirementStatusList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_STATUS_LIST),
    statusList,
})
export const setCcRequirementStatusIds = (statusIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_STATUS_IDS),
    statusIds,
})
export const setCcRequirementStatusEdit = (status: CcRequirementStatus) => ({
    type: inferLiteral(types.CC_REQUIREMENT_STATUS_EDIT),
    status,
})
export const setCcRequirementStatusReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_STATUS_RELOAD_LIST),
    value,
})
export const setCcRequirementStatusReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_STATUS_RELOAD_EDIT),
    value,
})
